import { Space, Table, message, DatePicker, Button, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import React, { useEffect, useState } from 'react';
import { requestUserList} from '../../../axios/http';
import { useNavigate } from 'react-router-dom';
import { SearchOutlined } from '@ant-design/icons';
import moment from "moment/moment";
import {ChildDevice} from "../child/device";
import {UserChild} from "../child/user";

type Props = {};
export const User = (props: Props) => {
  let [data, setData] = useState<DataType[]>([]);
  let navigate = useNavigate();
  const { RangePicker } = DatePicker;
  const [selectedDates, setSelectedDates] = useState<number[]>([]);
  let [id, setId] = useState<number>(0);
  let [show, setShow] = useState<boolean>(false);

  interface DataType {
    id: number;                 // 用户 ID
    u_id: string;               // 用户唯一标识符
    user_login: string;         // 用户登录名
    user_nick: string;          // 用户昵称
    email: string;              // 邮箱地址
    active: boolean;            // 是否活跃
    active_token: string;       // 活跃 Token
    picture: string;            // 用户头像
    create_time: number;        // 创建时间，时间戳
  };

  const columns: ColumnsType<DataType> = [
    {
      title: 'uuid',
      dataIndex: 'u_id',
      key: 'u_id',
      render: text => <a>{text}</a>,
    },
    {
      title: 'User Login',
      dataIndex: 'user_login',
      key: 'user_login',
    },
    {
      title: 'User Nick',
      dataIndex: 'user_nick',
      key: 'user_nick',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'active',
      dataIndex: 'active',
      key: 'active',
      render: text => <div>
        {text ? <Tag color={'green'} key={text}>
          online
        </Tag>:<Tag color={'red'} key={text}>
          Disconnection
        </Tag>}
      </div>,
    },
    {
      title: 'Active Token',
      dataIndex: 'active_token',
      key: 'active_token',

    },
    {
      title: 'Picture',
      dataIndex: 'picture',
      key: 'picture',
      render: text => <a>{text && <img style={{width:'50px', height:'50px', objectFit:'cover'}} src={text}/>}</a>,
    },
    {
      title: 'create_time',
      dataIndex: 'create_time',
      key: 'create_time',
      render: text => <a>{text&&moment(text).format('YYYY-MM-DD HH:mm:ss')}</a>,
    },
    {
      title: 'Edit Details',
      dataIndex: 'id',
      key: 'id',
      render: text => <Button type="primary" icon={<SearchOutlined />} size={'small'} onClick={()=>{
        setId(text)
        setShow(true)
      }}>
        Show
      </Button>,
    },

  ];

  async function getUserList(){
   let result = await requestUserList()
    setData(result.data.users)
  }

  useEffect(() => {
    getUserList()
  }, []);

  return (
    <div>
        <Table columns={columns} dataSource={data} />
      {show && <UserChild id={id} key={id}/>}
    </div>
  );
};
